import { render, staticRenderFns } from "./AkbsRegisteredCard.vue?vue&type=template&id=141791a1&scoped=true&"
import script from "./AkbsRegisteredCard.vue?vue&type=script&lang=js&"
export * from "./AkbsRegisteredCard.vue?vue&type=script&lang=js&"
import style0 from "./AkbsRegisteredCard.vue?vue&type=style&index=0&id=141791a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141791a1",
  null
  
)

export default component.exports